<div class="mt-2">
	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<div *ngIf="items.length > 0">
		<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
			<thead>
				<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
					[displayOptions]="displayOptions">
				</tr>
			</thead>
			<tbody *ngIf="!loading && itemsToShow?.length > 0">
				<tr *ngFor="let item of itemsToShow; let i = index">
					<td class="text-center">
						<fa-icon *ngIf="item['__will_send'] === 'y'" [icon]="['fas', 'check']" size="sm">
						</fa-icon>
						<fa-icon *ngIf="item['__will_send'] === 'n'" [icon]="['fas', 'times']" size="sm">
						</fa-icon>
					</td>
					<td>{{ item['__reason'] }}</td>
					<td class="text-center">
						<span *ngIf="item['__reason'] === ''">
							{{ item['__send_at'] | date:'shortTime' }}
						</span>
					</td>
					<td class="text-nowrap">{{ item.name }}</td>
					<td>{{ item.org_name }}</td>
					<td>{{ item.email }}</td>
					<td class="text-nowrap">
						{{ item.last_login | date: ac.tableDateFmt }}
					</td>
				</tr>
			</tbody>
		</table>
		<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
			[centered]="false"></app-paging-bar>
	</div>

</div>